import { useRef, useState, useEffect } from "react";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Manaf Hasan",
    role: "CFO/Founder",
    quote: "Ultricies purus senectus facilisi montes nascetur gravida justo habitasse nullam, cursus malesuada posuere aliquam mustona sociosqu magnis condimentum neque.",
    rating: 5,
    accent: "orange",
  },
  {
    name: "Manaf Hasan",
    role: "CFO/Founder",
    quote: "Purus Ultricies senectus nascetur gravida justo habitasse nullam, cursus malesuada posuere aliquam mustona sociosqu magnis condimentum neque.",
    rating: 5,
    accent: "blue",
  },
  {
    name: "Sarah Lin",
    role: "Product Manager",
    quote: "Working with the team was seamless from day one — clear communication, sharp execution, and results that exceeded what we expected.",
    rating: 5,
    accent: "blue",
  },
  {
    name: "David Chen",
    role: "CTO",
    quote: "Reliable, fast, and genuinely invested in getting the details right. Would work with them again without hesitation.",
    rating: 5,
    accent: "orange",
  },
];

function useInView(threshold = 0.1) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

function Stars({ count }) {
  return (
    <span className="ts-stars" aria-label={`${count} out of 5 stars`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} width="14" height="14" viewBox="0 0 20 20" fill={i < count ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1">
          <path d="M10 1.5l2.6 5.6 6.1.6-4.6 4.1 1.3 6-5.4-3.1-5.4 3.1 1.3-6-4.6-4.1 6.1-.6z" />
        </svg>
      ))}
    </span>
  );
}

export default function TestimonialsSection() {
  const [secRef, inView] = useInView(0.1);
  const trackRef = useRef(null);

  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollStart = useRef(0);
  const autoScroll = useRef(true);

  // Duplicate the list so the loop feels seamless
  const loopItems = [...testimonials, ...testimonials];

  // Auto-scroll loop
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let frameId;
    const speed = 0.5; // px per frame

    const step = () => {
      if (autoScroll.current && !isDragging.current) {
        track.scrollLeft += speed;
        // Reset seamlessly once we've scrolled past the first set
        const half = track.scrollWidth / 2;
        if (track.scrollLeft >= half) {
          track.scrollLeft -= half;
        }
      }
      frameId = requestAnimationFrame(step);
    };
    frameId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frameId);
  }, []);

  // Drag handlers (mouse + touch)
  const onPointerDown = (e) => {
    isDragging.current = true;
    autoScroll.current = false;
    startX.current = (e.touches ? e.touches[0].pageX : e.pageX);
    scrollStart.current = trackRef.current.scrollLeft;
    trackRef.current.classList.add("ts-track--dragging");
  };

  const onPointerMove = (e) => {
    if (!isDragging.current) return;
    const x = (e.touches ? e.touches[0].pageX : e.pageX);
    const walk = x - startX.current;
    trackRef.current.scrollLeft = scrollStart.current - walk;
  };

  const endDrag = () => {
    isDragging.current = false;
    trackRef.current?.classList.remove("ts-track--dragging");
    // resume auto-scroll after a short pause
    setTimeout(() => { autoScroll.current = true; }, 1200);
  };

  return (
    <section className="ts-section" id="testimonials" ref={secRef}>
      <div className="ts-container">

        <div className={`ts-header${inView ? " ts-header--in" : ""}`}>
          <span className="ts-eyebrow">Testimonials</span>
          <h2 className="ts-heading">Trusted By Global Client&rsquo;s</h2>
        </div>
      </div>

      <div
        className="ts-track"
        ref={trackRef}
        onMouseDown={onPointerDown}
        onMouseMove={onPointerMove}
        onMouseUp={endDrag}
        onMouseLeave={endDrag}
        onTouchStart={onPointerDown}
        onTouchMove={onPointerMove}
        onTouchEnd={endDrag}
      >
        {loopItems.map((t, i) => (
          <div
            key={t.name + i}
            className={`ts-card ts-card--${t.accent}`}
          >
            <p className="ts-quote">{t.quote}</p>
            <div className="ts-footer">
              <div className="ts-person">
                <div className="ts-avatar">{t.name.charAt(0)}</div>
                <div>
                  <p className="ts-name">{t.name}</p>
                  <p className="ts-role">{t.role}</p>
                </div>
              </div>
              <Stars count={t.rating} />
            </div>
          </div>
        ))}
      </div>

    </section>
  );
}